"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const SortDesc = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 20,
  height: 14,
  viewBox: "0 0 20 14",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.995 7.994c.266 0 .522.107.71.296a1 1 0 010 1.42l-3.996 4a1 1 0 01-.33.21.938.938 0 01-.76 0 1 1 0 01-.33-.21l-3.995-4a1.005 1.005 0 011.419-1.42L14 10.59V1a1 1 0 111.998 0v9.59l2.288-2.3a.999.999 0 01.709-.296zM1 2a1 1 0 000 2h8a1 1 0 100-2H1zM0 7a1 1 0 011-1h5a1 1 0 010 2H1a1 1 0 01-1-1zm1 3a1 1 0 100 2h2a1 1 0 100-2H1z",
  fill: "#6E7F96",
  className: "fill"
}));
var _default = exports.default = SortDesc;